/* eslint-disable  no-console */
const isDev = process.env.NODE_ENV === "development"

const $log = isDev ? console.log : () => {}
$log.warn = isDev ? console.warn : () => {}
$log.error = isDev ? console.error : () => {}
$log.trace = isDev ? console.trace : () => {}

export default $log
